"use client"

import { Route } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RouteIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RouteIcon = component(Icon)({ as: Route })
